import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../shared/my-constants';

@Injectable()
export class IntraOperativeInstructionDetailsService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private AddRecord = webapi + 'trn_ot_intra_operative_instruction_details/create';
    private AddListRecord = webapi + 'trn_ot_intra_operative_instruction_details/createbylistbyopsid/';
    private UpdateListRecord = webapi + 'trn_ot_intra_operative_instruction_details/updatebylistbyopdid/';
    private GetRecord = webapi + 'trn_ot_intra_operative_instruction_details/bypatientid/';
    private GetRecordByOpsId = webapi + 'trn_ot_intra_operative_instruction_details/byopsid/';
    private GetRecordByOpdId = webapi + 'trn_ot_intra_operative_instruction_details/byopdid/';
    private DeleteRecord = webapi + 'trn_ot_intra_operative_instruction_details/delete/';

    constructor(private http: Http) { }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordListService(opsId, model: any) {
        return this.http.post(this.AddListRecord + opsId, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateByOpdIdRecordListService(model: any) {
        return this.http.post(this.UpdateListRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordByOpsIdService(opsId) {
        return this.http.get(this.GetRecordByOpsId + '/' + opsId )
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordByOpdIdService(opdId) {
        return this.http.get(this.GetRecordByOpdId + '/' + opdId )
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.get(this.DeleteRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/operation-theater/ot-schedule/intra-operative-instruction-details/intra-operative-instruction-details.service.ts